import {
    DocumentReference,
    MAX_DOCUMENT_CATEGORY_LABEL_LENGTH,
    MAX_DOCUMENT_FILE_NAME_LENGTH,
} from "@common/schemas/documentReference.schema";

const FALLBACK_FILE_NAME = "Untitled document";

export interface AskAboutDocument {
    id: number;
    fileName: string;
    documentCategory?: { label: string } | null;
}

/**
 * Bounds a client-supplied snapshot string to the schema's max length,
 * falling back when the source is empty so the resulting draft reference
 * always satisfies `DocumentReferenceSchema` (which rejects empty/over-long
 * values only at message-send time).
 */
function toBoundedFileName(fileName: string): string {
    const trimmed = fileName.trim();
    const value = trimmed.length === 0 ? FALLBACK_FILE_NAME : trimmed;
    return value.slice(0, MAX_DOCUMENT_FILE_NAME_LENGTH);
}

export function buildDocumentReferences({
    taskId,
    documents,
}: {
    taskId: string;
    documents: AskAboutDocument[];
}): DocumentReference[] {
    return documents.map((document) => {
        const fileName = toBoundedFileName(document.fileName);
        return {
            taskId,
            documentId: document.id,
            fileName,
            documentCategoryLabel:
                document.documentCategory?.label?.slice(
                    0,
                    MAX_DOCUMENT_CATEGORY_LABEL_LENGTH,
                ) ?? null,
            label: fileName,
        };
    });
}
